const AUTO_ASSIGNED_EMOJIS = new Set(["🚀", "🎤", "📚", "⚡", "✨"]);

export function launchInitials(name: string): string {
  const cleaned = name.trim().replace(/^[«"'„""‹›(\[]+/, "");
  if (!cleaned) return "—";
  const first = [...cleaned][0] ?? "";
  const letter = first.toLocaleUpperCase("ru");
  const numMatch = cleaned.match(/(\d{1,2})\s*$/);
  if (numMatch) return letter + numMatch[1];
  return letter;
}

export function launchAvatarText(launch: { emoji?: string | null; name: string }): string {
  const e = launch.emoji?.trim() ?? "";
  if (e && !AUTO_ASSIGNED_EMOJIS.has(e)) return e;
  return launchInitials(launch.name);
}
